export default __webpack_public_path__ + "static/media/ECONOMIA.b087df7e.pdf";